var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 11.399c-3.613 0-6.568-2.565-6.568-5.7C2.182 2.565 5.137 0 8.75 0s6.568 2.565 6.568 5.7c0 3.134-2.956 5.699-6.568 5.699zm0-1.341c2.762 0 5.021-1.962 5.021-4.359 0-2.397-2.26-4.358-5.022-4.358-2.762 0-5.022 1.961-5.022 4.358 0 2.397 2.26 4.358 5.022 4.358zm0 4.69c-2.897 0-5.602.972-7.649 2.749L0 16.542c2.337-2.012 5.447-3.135 8.75-3.135s6.413 1.123 8.75 3.135l-1.101.955c-2.048-1.777-4.752-2.749-7.649-2.749z"
  })));
};

export default SvgLogin;